import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';
import { USAGE_TYPE } from '@/lib/api/material-process';

const MaterialLibraryPage = lazy(() =>
  import('@/pages/ads/material-process/material-library-page').then((m) => ({
    default: m.MaterialLibraryPage,
  })),
);

export const Route = createFileRoute('/_app/ads/materials/review')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:material-review', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <MaterialLibraryPage usageType={USAGE_TYPE.REVIEW} />
    </Suspense>
  ),
});
